import { render, staticRenderFns } from "./ChildQuestionTable.vue?vue&type=template&id=02fbceee"
import script from "./ChildQuestionTable.vue?vue&type=script&lang=js"
export * from "./ChildQuestionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports